/**
 * Caché en memoria + deduplicación de peticiones GET a Strapi durante la vida de la SPA.
 * Evita repetir el mismo JSON al navegar entre vistas que remontan componentes.
 */

const jsonCache = new Map();
const inflight = new Map();

function cacheKey(url, method) {
  return `${method}:${url}`;
}

/**
 * @param {string} url URL completa del endpoint Strapi
 * @param {RequestInit} [init] Opciones de fetch (solo se cachea method GET)
 * @returns {Promise<any>} Cuerpo JSON parseado
 */
export function fetchStrapiGetJsonCached(url, init = {}) {
  const method = (init && init.method) || "GET";
  if (method !== "GET") {
    return fetch(url, { ...init, method }).then((r) => r.json());
  }

  const key = cacheKey(url, "GET");
  if (jsonCache.has(key)) {
    return Promise.resolve(jsonCache.get(key));
  }

  const existing = inflight.get(key);
  if (existing) return existing;

  const p = fetch(url, { ...init, method: "GET" })
    .then((res) => res.json())
    .then((json) => {
      jsonCache.set(key, json);
      inflight.delete(key);
      return json;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, p);
  return p;
}

/** Útil para tests o si en el futuro se necesita forzar recarga de CMS */
export function clearStrapiJsonCache() {
  jsonCache.clear();
  inflight.clear();
}
